export default function Footer() {
  return (
    <div className="footer-wrapper">
      <div className="footer">
        <img className="logo" src="/assets/landingPage/ciplLogo.svg" alt="" />
        <p className="copyright">© 2025 YES Version 1.0</p>
      </div>
    </div>
  );
}
